import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const Pagination = ({
  currentPage,
  totalPages,
  onPageChange,
  totalItems,
  itemsPerPage,
  BaseButton
}) => {
  if (totalPages <= 1) {
    return null;
  }

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  return (
    <div className="pt-4 mt-4 border-t border-gray-200 flex justify-between items-center">
      <span className="text-sm text-gray-600">
        Mostrando {indexOfFirstItem + 1}-{Math.min(indexOfLastItem, totalItems)} de {totalItems} registros
      </span>
      <div className="flex items-center gap-2">
        <BaseButton
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
          variant="outline"
          size="sm"
          icon={ChevronLeft}
        />
        <span className="px-4 py-1.5 text-sm font-medium text-gray-700">
          {currentPage} / {totalPages}
        </span>
        <BaseButton
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          variant="outline"
          size="sm"
          icon={ChevronRight}
        />
      </div>
    </div>
  );
};

export default Pagination;